import { useEffect, useState } from "react";
import { createClickableLink } from "../../../../components/common/datatable/DataTableUtils";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import { SearchDatePickerWrapper } from "../../../../components/common/datatable/filter/SearchDatePickerWrapper";
import { formatValueAsDateAndTime } from "../../../../helpers/utils/DateUtils";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import IconButton from "../../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useLazyExportThirdPartyProviderDataQuery, useSearchThirdPartyProviderApiQuery } from "../thirdPartyProvider";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";


const ThirdPartyProvider = () => {

    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Third Party Provider");
    const navigate = useNavigate();
    const [triggerExportThirdPartyProviderDataQuery] = useLazyExportThirdPartyProviderDataQuery();

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Third Party Providers", url: "" }]
    )

    useEffect(() => {
        document.title = 'Third Party Providers';
    }, []);


    const columns: DataTableColumn[] = [
        {
            label: "Name", accessor: "name", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                if (hasPermission(["HOATPP-R"])) {
                    let path = "/third-party-providers/" + props.row.original.id;
                    return createClickableLink(path, props.value, userSetting);
                } else {
                    return <>
                        <span>{props.row.original.name}</span>
                    </>
                }
            },

            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Name..."}
                    name={"thirdPartyProviderName"} accessor={"name"} />,
                overrideFilterAccessor: "name"
            }],
        },
        {
            label: "Website", accessor: "website",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Website..."}
                    name={"website"} accessor={"website"} />,
                overrideFilterAccessor: "website"
            }],
        },
        {
            label: "Created On", accessor: "creationDate", cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.creationDate, 'MM/DD/YY h:mm a');
            }, filterOptions: [{
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateFrom"} />,
                overrideFilterAccessor: "createdDateFrom",
                overrideFilterLabel: "Created Date - From",
            }, {
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateTo"} />,
                overrideFilterAccessor: "createdDateTo",
                overrideFilterLabel: "Created Date - To",
            }]
        }
    ]


    return (

        <div className="px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>
            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchThirdPartyProviderApiQuery,
                    exportAction: triggerExportThirdPartyProviderDataQuery
                }}
                buttonOptions={{
                    addButton:
                    {
                        button: <IconButton
                            icon={<FaPlus />}
                            hasBackground={true}
                            onClick={() => {
                                navigate("/third-party-providers/create")
                            }}
                            title={"Create Third Party Provider"}
                        />,
                        permissions: ["HOATPP-C"]
                    },
                }}
                userSettingGroup={"Third Party Provider"}
                defaultSortOptions={{
                    accessor: "creationDate",
                    direction: "asc"
                }}
                basePermission={"HOATPP"}
            />
        </div>
    );
}

export default ThirdPartyProvider;